import { endpoints } from "@valenzinsights/app-config";
import { Grid } from "@valenzinsights/core-component";
import { ValenzLogoIconSvg } from "@valenzinsights/images";
import { Error403 } from "@valenzinsights/shared-pages";
import { ReactWebChat } from "@valenzinsights/webchat-component";

import React, { useEffect } from "react";

import { useMsal } from "@azure/msal-react";

import {
	botAvatarBackgroundColor,
	copyFunctionalityControlId,
	copyFunctionalityTableControlId,
	feedbackDislikeControlId,
	feedbackDislikeTableControlId,
	feedbackLikeControlId,
	feedbackLikeTableControlId,
	popupCancelId,
	popupCardPrefixId,
	popupCloseId,
	popupHTMLPrefixId,
	popupSubmitId,
	skipCopyPrefixId,
	thoughtProcessControlId,
	thoughtProcessTableControlId,
	updateExistingCardPrefixId,
	userAvatarBackgroundColor,
} from "./Constants";
import { copyAccessor, isDirectLineTokenValid } from "./apis";
import {
	cardLayoutGridExpStyle,
	StyledWebChatModule,
	webChatStyle,
} from "./styles/webchatStyle";

export function LibraryWebChat({
	jumpToPage,
}: {
	jumpToPage: (pageNumber: number) => void;
}) {
	const [directLineToken, setDirectLineToken] = React.useState("");
	const [isWebChatVisible, setWebChatVisibility] = React.useState(false);
	const [hasError, setHasError] = React.useState(false);
	const { instance } = useMsal();
	const userAdAccount = instance.getAllAccounts()[0];

	const docId = new URLSearchParams(location.search).get("documentid");
	const documentName = new URLSearchParams(location.search).get("document");

	useEffect(() => {
		displayLoadingIndicator();
		const botConversationId = localStorage
			.getItem(`libBotConversationId_${docId}`)
			?.toString();

		isDirectLineTokenValid(
			botConversationId,
			displayWebChat,
			displayErrorMessage,
			docId ? docId : undefined,
			documentName ? documentName : undefined,
		);
	}, []);

	const utilsConfig = {
		copyFunctionalityControlId: copyFunctionalityControlId,
		skipCopyPrefixId: skipCopyPrefixId,
		copyFunctionalityTableControlId: copyFunctionalityTableControlId,
		copyAccessor: copyAccessor,
		updateExistingCardPrefixId: updateExistingCardPrefixId,
		popupCloseId: popupCloseId,
		popupCancelId: popupCancelId,
		popupCardPrefixId: popupCardPrefixId,
		popupHTMLPrefixId: popupHTMLPrefixId,
		popupSubmitId: popupSubmitId,
		botAvatarImage: ValenzLogoIconSvg,
		userAvatarImage: "",
		userAvatarInitials: userAdAccount
			? (userAdAccount?.name
					?.split(" ")
					?.map((word: any) => word[0])
					?.join("")
					?.toLocaleUpperCase() ?? "")
			: "",
		botAvatarBackgroundColor: botAvatarBackgroundColor,
		userAvatarBackgroundColor: userAvatarBackgroundColor,
		feedbackLikeControlId: feedbackLikeControlId,
		feedbackDislikeControlId: feedbackDislikeControlId,
		feedbackLikeTableControlId: feedbackLikeTableControlId,
		feedbackDislikeTableControlId: feedbackDislikeTableControlId,
		hideUploadButton: true,
		thoughtProcessControlId: thoughtProcessControlId,
		thoughtProcessTableControlId: thoughtProcessTableControlId,
	};

	const displayWebChat = (directLineToken = "") => {
		setDirectLineToken(directLineToken);
		setHasError(false);
		setWebChatVisibility(true);
	};

	const displayLoadingIndicator = () => {
		setHasError(false);
		setWebChatVisibility(true);
	};

	const displayErrorMessage = () => {
		setHasError(true);
		setWebChatVisibility(true);
	};

	const onCardClick = (event: MouseEvent) => {
		if (
			event.target instanceof HTMLElement &&
			event.target.classList.contains("ac-anchor")
		) {
			event.preventDefault();
			if (event.target instanceof HTMLAnchorElement) {
				const linkText = event.target.textContent || "";
				const regex = /-(\d+)\.pdf/;
				const match = linkText.match(regex); // Use match() to extract
				match && match.length && jumpToPage(Number(match[1]) - 1);
			}
		}
	};

	const renderExpandedBookmarkCardsView = (
		<Grid
			container
			direction="row"
			id="webchat-container"
			style={{ padding: "10px", ...cardLayoutGridExpStyle }}
		>
			<StyledWebChatModule item lg={12}>
				<>
					{isWebChatVisible && !hasError ? (
						<ReactWebChat
							endpoints={endpoints.directlineBotConversationApiUrl}
							style={{ ...webChatStyle }}
							conversationId={
								localStorage.getItem(`libBotConversationId_${docId}`)?.toString() ?? ""
							}
							token={directLineToken}
							autoCompleteControlsConfig={null}
							utilsConfig={utilsConfig}
							onCardClick={onCardClick}
						/>
					) : (
						<></>
					)}
				</>
			</StyledWebChatModule>
		</Grid>
	);

	return <>{!hasError ? renderExpandedBookmarkCardsView : <Error403 />}</>;
}
